import React from "react";
import './style.less';
import { Row, Col, Image, Carousel } from "antd";

export default class MobileTrainingContent1 extends React.Component {
  
    render() {
        return (
            <div className={'mobile-training-content1'}>
                <div className={'content-box'}>
                    <Carousel autoplay>
                        <div className="explain">
                            <Image preview={false} height={219} style={{ width: 320 }} src={"https://qiniu.metridynamic.com/image/training/20220609-134523.png"}/>
                            <p className={"title"}>专业的无人机飞行员</p>
                            <p className={"content"}>
                            <div className="split-line"></div>
                                为满足P系列无人机产品试飞、交付、客户培训、AOPA培训等需求，我们有专业技术人员和管理人员，针对无人机产品和解决方案提供系统化和层次化的专业培训服务。</p>
                        </div>
                        <div className="explain">
                            <Image preview={false} height={219} style={{width:320}} src={"http://qiniu.metridynamic.com/image/new-official-en/training/20220419-152027.png"}/>
                            <p className={"title"}>设施完备的飞行基地</p>
                            <p className={"content"}>
                            <div className="split-line"></div>
                                力动几何飞机基地位于成都市青白江区，基地占地面积1000亩，距离成都仅 22公里，交通便利，环境优美, 基础设施齐全，周边旅游景点众多，满足各种测试，演示, 培训等需求。</p>
                        </div>
                    </Carousel>
                </div>
            </div>
        )
    }
}
